import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PendingApprovalPipe } from './pendingApproval.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [PendingApprovalPipe],
    providers: [PendingApprovalPipe],
    exports: [PendingApprovalPipe],
})
export class PendingApprovalPipeModule {}
